import React, { useState } from "react";
import PdfViewer from "../components/Pdf/PdfViewer";
import { useDocs } from "../hooks/useDoc";
import { Empty } from "antd";
import { Accordion, AccordionTab } from "primereact/accordion";
import { usePageHeaderByKey } from "../hooks/usePageHeaderBykey";
import PublicPageShell from "../components/PublicPageShell";

export const Doc = () => {
  const { pageHeader, isLoading:loading } = usePageHeaderByKey("docs");
  const { docs, isLoading, error } = useDocs();
  const [activeIndex, setActiveIndex] = useState(0);

  if (isLoading || loading)
    return (
      <div className="flex h-screen justify-center items-center">
        <i
          className="pi pi-spin pi-spinner text-red-700"
          style={{ fontSize: "2rem" }}
        ></i>
      </div>
    );
  if (error) return <div>Error: {error.message}</div>;

  return (
      <PublicPageShell>
      <div className="flex flex-col justify-center w-full">
        <h1 className="text-2xl mb-4 text-left font-bold text-black uppercase">
          {pageHeader?.h1 || "HOA DOCUMENTS"}
        </h1>
        <div>
          {docs && docs?.length > 0 ? (
            <Accordion
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
              className="custom-tabview"
            >
              {docs &&
                docs.map((doc, index) => (
                  <AccordionTab
                    header={doc.title}
                    key={index}
                    headerClassName={`text-[#003049] uppercase ${
                      activeIndex === index ? "active-tab" : ""
                    }`}
                  >
                    <PdfViewer pdfUrl={doc.url} />
                  </AccordionTab>
                ))}
            </Accordion>
          ) : (
            <div className="w-full min-h-screen flex justify-center items-center">
              <Empty />
            </div>
          )}
        </div>
      </div>
      </PublicPageShell>
  );
};
